import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class FridgeIcon extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e'
    };

    render() {
        const { color, size } = this.props;
        return (
            <svg height={(size / 1.5).toString()} width={(size / 1.5).toString()} viewBox="0 0 213.63 300">
                <path
                    d="M49.98 65.39C49.98 69 46.73 72 42.7 72s-7.27-3-7.27-6.61V35.91c0-3.63 3.26-6.57 7.27-6.57s7.28 2.94 7.28 6.57zM192.66 0H20.99c-11.58 0-21 10.07-21 22.5v78h213.64v-78c0-12.43-9.39-22.5-21-22.5zm0 0M35.43 159.7c0-4.8 3.26-8.7 7.27-8.7s7.28 3.9 7.28 8.7v39c0 4.81-3.26 8.7-7.28 8.7s-7.27-3.89-7.27-8.7zM.01 280.63c0 10.7 9.4 19.37 21 19.37h171.65c11.58 0 21-8.67 21-19.37V115.1H.01zm0 0"
                    fill={color}
                />
            </svg>
        );
    }
}

export default withTheme(FridgeIcon);



// WEBPACK FOOTER //
// ./data/common/iconsvg/FridgeIcon.js